import React from "react";
import disclaimerStyles from './AlmeDisclaimer.styles';
import { Container, Typography } from "@material-ui/core";
import { WithStyles, withStyles } from '@material-ui/core/styles';
import { FocusComponentProps } from "../../models/ComponentProps";
import { AlmeDisclaimerConfig } from "./AlmeDisclaimerConfig";
import { FormattedMessage } from "react-intl";

interface AlmeDisclaimerProps extends WithStyles<typeof disclaimerStyles> {
    almeConfig: AlmeDisclaimerConfig;
    focusProps?: FocusComponentProps;
}

const AlmeDisclaimer: React.FC<AlmeDisclaimerProps> | null = (props: AlmeDisclaimerProps) => {
    if (props.almeConfig.disclaimer.isEnabled) {
        return (
            <Container disableGutters className={props.classes.disclaimer}>
                <Typography variant={props.almeConfig.disclaimer.styles.font}>
                    <FormattedMessage
                        id="disclaimer.text"
                        defaultMessage="Default disclaimer text"
                        description="Disclaimer text element" />
                </Typography>
            </Container>
        );
    }
    else {
        return null;
    }

};
export default withStyles(disclaimerStyles)(AlmeDisclaimer);
